const StatusInfo = (props) => {
  const { status, className, ...rest } = props;
  return (
    <>
      {status ? 
        <>
          <div className={`status-info ${className} ${status.replaceAll(" ","-").toLowerCase()}`}>{status}</div>
        </>
      : 
      ''
      }
      
    </>
  );
};

export default StatusInfo;
